var LpBoclipsFetcher = function() {
  function LpBoclipsFetcher(_ref) {
    this.boclips_search_path = _ref.boclips.search_path.replace(/(\?|$)/, '.json$1');
    this.xhr = null;
  }

  LpBoclipsFetcher.prototype.loadSearch = function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        search_params: null,
        page: null,
        per_page: null,
        search_count: 0,
      },
      search_params = _ref2.search_params,
      page = _ref2.page,
      per_page = _ref2.per_page,
      search_count = _ref2.search_count;

    var data = {
      search: search_params || LP.config.search_params,
      page: page,
      search_count: search_count,
    };
    if (per_page) {
      data.per_page = per_page;
    }
    if (this.xhr) {
      this.xhr.abort();
    }
    this.xhr = $.ajax({
      url: this.boclips_search_path,
      type: 'GET',
      dataType: 'json',
      cache: false,
      data: data
    });
    return this.xhr;
  };

  LpBoclipsFetcher.prototype.loadResourceModal = function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      url: null,
      data: {}
    };
    var url = _ref.url;
    var data = _ref.data;
    return $.ajax({
      url: url.replace(/(\?|$)/, '.json$1'),
      type: 'GET',
      dataType: 'json',
      cache: false,
      data: data
    });
  };

  return LpBoclipsFetcher;
}();

if (LP && LP.module('LpBoclips')) {
  LP.module('LpBoclips').LpBoclipsFetcher = LpBoclipsFetcher
}
